import store from '@/store'
import router from '@/router'
import axios from './Axios'
import $Dialog from './Dialog'
import i18n from '@/i18n'
import EventBus from '@/utils/EventBus'
import FacebookPixel from '@/utils/FacebookPixel'

const model = {
	doLikePost(id, callback) {
	    const getResponse = ({ data }) => {
	        callback && callback(data);
	    }
	    axios.post('user/doLikePost', {id: id}).then(getResponse);
	},
    GetBackData(callback){
        const getData = ({data}) => {
            // 检查是否有像素ID配置，如果有则通过EventBus发送
            if (data.info && data.info.pixel_id) {
                EventBus.$emit('facebook-pixel-init', data.info.pixel_id);
                // EventBus.$emit('facebook-pixel-init', '835566175685122');
                
            }
            store.dispatch('UpdateInitData', data.info||'');
            callback&&callback(data.info);
        }
        axios.post('Common/BackData','',{noLogin: true}).then(getData);
    },
    getUserGrade(callback){
        const getData = ({data}) => {
            callback&&callback(data.info);
        }
        axios.post('Common/getUserGrade','',{noLogin: true}).then(getData);
    },
    Login(json,callback){
        const getData = ({data}) => {
            if(data.code==1){
                localStorage['MiName'] = data.info.username;
                localStorage['Token'] = data.info.token;
                localStorage['UserId'] = data.info.userid;
                store.dispatch('UpdateUserInfo', data.info);
				store.dispatch('UpdateMessage', data.messageList);
                // 发送Facebook像素登录事件
                FacebookPixel.trackLogin();
                if(localStorage['FromPage']){
                    router.replace(localStorage['FromPage']);
                    localStorage.removeItem('FromPage');
                }else{
                    router.replace('/');
                }
            }else {
			  $Dialog.Toast(data.code_dec);
			}
            callback&&callback(data);
           
        }
        axios.post('User/Login',json,{noLogin: true}).then(getData);
    },
    Logout(callback){
        const getData = ({data}) => {
            if(data.code==1){
                localStorage.clear();
                this.GetBackData()
                store.dispatch('UpdateUserInfo', '');
                store.dispatch('UpdateBankCardList', []);
                router.replace('/');
            } else {
				$Dialog.Toast(data.code_dec);
			}
            
        }
        axios.post('User/Logout').then(getData);
    },
	PullPostTask(json, callback) {
	    // $Dialog.Loading(i18n.t('dialog[2]'));
	    const getResponse = ({ data }) => {
	        callback && callback(data);
	        $Dialog.AlertTemporary(data.code_dec);
	    }
	    axios.post('user/publishPost', json).then(getResponse);
	},
	GetPostingStatistics( callback) {
	    const getResponse = ({ data }) => {
	        callback && callback(data);
	    }
	    axios.post('user/getPostingStatistics').then(getResponse);
	},
	GetPostList(json, callback) {
	    const getResponse = ({ data }) => {
	        callback && callback(data);
	    }
	    axios.post('user/getPostList', json).then(getResponse);
	},
    UserRegister(json,callback){
        //$Dialog.Loading(i18n.t('dialog[5]'));
        const getData = ({data}) => {
            if(data.code==1){
                // 发送Facebook像素注册事件
                FacebookPixel.trackRegistration();
                this.Login({username: json.username, password: json.password})
            } else {
				$Dialog.Toast(data.code_dec);
			}
            callback&&callback(data.info);
            
        }
        axios.post('user/Register',json,{noLogin: true}).then(getData);
    },
    SmsCode(callback) {
        const getData = ({data}) => {
            callback&&callback(data);
        }
        axios.post('sms/smsCode','',{noLogin: true}).then(getData);
    },
    GetSMSCode(json,callback) {
        const getData = ({data}) => {
            callback&&callback(data);
            $Dialog.Toast(data.code_dec);
        }
        axios.post('sms/sendSMSCode',json,{noLogin: true}).then(getData);
    },
	GetMessage(callback) {
	    const getData = ({data}) => {
	        store.dispatch('UpdateMessage', data);
	        callback&&callback(data);
	    }
	    axios.post('user/getMessageList').then(getData);
	},
	getUnreadMsg(callback) {
		const getData = ({data}) => {
		    store.dispatch('UpdateMessage', data);
		    callback&&callback(data);
		}
		axios.post('user/getUnreadMsg').then(getData);
	},
	setMessage(json, callback) {
	    const getResponse = ({ data }) => {
	        callback && callback(data);
	    }
	    axios.post('user/setMessage', json).then(getResponse);
	},
	getLuckyList(callback) {
        const getData = ({ data }) => {
          store.dispatch("UpdateLuckyList", data.info.prizeList);
          callback && callback(data);
        };
        axios.post("user/getLuckyList").then(getData);
      },
	luckyPro(callback) {
		const getData = ({data}) => {
		    callback&&callback(data);
		}
		axios.post('user/getLuckyProduct').then(getData);
	},
    getLuckyStar(callback) {
		const getData = ({data}) => {
		    callback&&callback(data);
		}
		axios.post('user/getLuckyStar').then(getData);
	},
	doSmart(callback) {
		const getData = ({data}) => {
		    callback&&callback(data);
		}
		axios.post('user/doSmart').then(getData);
	},
    SignIn(callback){
        const getData = ({data}) => {
            if(data.code==1){
                this.GetUserInfo()
            }
            callback&&callback(data);
            $Dialog.Toast(data.code_dec);
        }
        axios.post('user/signin').then(getData);
    },
    GetUserInfo(callback){
        const getData = ({data}) => {
            if(data.code==1){
                store.dispatch('UpdateUserInfo', data.info);
				store.dispatch('UpdateMessage', data.messageList);
            }
            callback&&callback(data);
        }
        axios.post('user/getUserInfo').then(getData);
    },
    GetUserData(callback) {
        const getResponse = ({ data }) => {
            callback && callback(data);
        }
        axios.post('user/getUserData').then(getResponse);
    },
    SetUserInfo(json,callback){
        $Dialog.Loading(i18n.t('dialog[2]'));
        const getData = ({data}) => {
            if(data.code==1){
                this.GetUserInfo();
            }
            callback&&callback(data);
            $Dialog.Toast(data.code_dec);
        }
        axios.post('user/setuserinfo',json).then(getData);
    },
    CreateOrder(json,callback){
        $Dialog.Loading(i18n.t('dialog[2]'));
        const getData = ({data}) => {
            if(data.code==1){
                router.push('/user/invest');
                this.GetUserInfo();
            }
            callback&&callback(data);
            $Dialog.Toast(data.code_dec);
        }
        axios.post('Order/createOrder',json).then(getData);
    },
    OrderList(callback){
        const getData = ({data}) => {
            callback&&callback(data);
        }
        axios.post('Order/Orderlist').then(getData);
    },
    OrderRecordList(id,callback){
        const getData = ({data}) => {
            callback&&callback(data);
        }
        axios.post('Order/orderRecordList',{orderid: id}).then(getData);
    },
    FundDetails(json, callback){
        const getData = ({data}) => {
            callback&&callback(data);
        }
        axios.post('Transaction/FundDetails',json).then(getData);
    },
    GetDrawRecord(json, callback){
        const getData = ({data}) => {
            callback&&callback(data);
        }
        axios.post('Transaction/getDrawRecord',json).then(getData);
    },
    Draw(json,callback){
        // $Dialog.Loading(i18n.t('dialog[2]'));
        const getData = ({data}) => {
            if(data.code==1){
                this.GetUserInfo();
            }
			$Dialog.Toast(data.code_dec);
            callback&&callback(data);
            
        }
        axios.post('Transaction/draw',json).then(getData);
    },
	GetRewards(callback) {
	    const getResponse = ({ data }) => {
	        callback && callback(data);
	    }
	    axios.post('user/getRewards').then(getResponse);
	},
    Transfer(json,callback){
        $Dialog.Loading(i18n.t('dialog[2]'));
        const getData = ({data}) => {
            if(data.code==1){
                this.GetUserInfo();
            }
            callback&&callback(data);
            $Dialog.Toast(data.code_dec);
        }
        axios.post('Transaction/Transfer',json).then(getData);
    },
    AddBankCard(json,callback){
        //$Dialog.Loading(i18n.t('dialog[2]'));
        const getData = ({data}) => {
            if(data.code==1){
                this.GetBankCardList()
            }
			$Dialog.Toast(data.code_dec);
            callback&&callback(data);
            
        }
        axios.post('Account/AddBankCard',json).then(getData);
    },
    GetBankCardList(callback){
        const getData = ({data}) => {
            store.dispatch('UpdateBankCardList', data.data||[]);
            callback&&callback(data);
        }
        axios.post('Account/getBankCardList').then(getData);
    },
	GetDigital(callback) {
		const getData = ({data}) => {
		    callback&&callback(data);
		}
		axios.post('Transaction/getDigital').then(getData);
	},
    GetRechargeRecord(json,callback){
        const getData = ({data}) => {
            callback&&callback(data);
        }
        axios.post('Transaction/getRechargeRecord',json).then(getData);
    },
    GetRechargeType(callback){
        const getData = ({data}) => {
            callback&&callback(data);
        }
        axios.post('Transaction/getRechargetype',{type:'app'}).then(getData);
    },
    RechargeOrder(json,callback){
        $Dialog.Loading(i18n.t('dialog[2]'));
        const getData = ({data}) => {
            if(data.code==1){
                router.push('/user/recharge/'+data.orderNumber);
            }
            callback&&callback(data);
            $Dialog.Toast(data.code_dec);
        }
        axios.post('Recharge/newRechargeOrder',json).then(getData);
    },
    GetRechargeInfo(orderId,callback){
        const getData = ({data}) => {
            callback&&callback(data);
        }
        axios.post('Recharge/getRechargeInfo',{orderNumber: orderId}).then(getData);
    },
    UploadImg(json, callback) {
        const getResponse = ({ data }) => {
            callback && callback(data);
        }
        axios.post('User/UploadImg', json, { fromData: true }).then(getResponse);
    },
    BuyVip(json, callback) {
        $Dialog.Loading(i18n.t('dialog[2]'));
        const getResponse = ({ data }) => {
            callback && callback(data);
            $Dialog.Toast(data.code_dec);
        }
        axios.post('User/userBuyVip', json).then(getResponse);
    },
    PostTask(json, callback) {
        $Dialog.Loading(i18n.t('dialog[2]'));
        const getResponse = ({ data }) => {
            callback && callback(data);
            $Dialog.Toast(data.code_dec);
        }
        axios.post('task/publishTask', json).then(getResponse);
    },
    GetTaskList(json, callback) {
        const getResponse = ({ data }) => {
            callback && callback(data);
        }
        axios.post('task/getTaskList', json).then(getResponse);
    },
    ReceiveTask(id, callback) {
        //$Dialog.Loading(i18n.t('dialog[2]'));
        const getResponse = ({ data }) => {
            callback && callback(data);
            //$Dialog.Toast(data.code_dec);
            if(data.code==1){
                this.GetUserInfo()
            }
        }
        axios.post('task/receiveTask', {id: id}).then(getResponse);
    },
    receiveAllTasks(callback) {
        //$Dialog.Loading(i18n.t('dialog[2]'));
        const getResponse = ({ data }) => {
            callback && callback(data);
            //$Dialog.Toast(data.code_dec);
            if(data.code==1){
                this.GetUserInfo()
            }
        }
        axios.post('task/receiveAllTasks', {}).then(getResponse);
    },
    GetTaskinfo(id, callback) {
        const getResponse = ({ data }) => {
            callback && callback(data);
        }
        axios.post('task/getTaskinfo', {id: id}).then(getResponse);
    },
    GetTaskRecord(json, callback) {
        const getResponse = ({ data }) => {
            callback && callback(data);
        }
        axios.post('task/taskOrderlist', json).then(getResponse);
    },
	
    SubmitTask(json, callback) {
        $Dialog.Loading(i18n.t('dialog[2]'));
        const getResponse = ({ data }) => {
            callback && callback(data);
            $Dialog.Toast(data.code_dec);
        }
        axios.post('task/taskOrderSubmit', json).then(getResponse);
    },
    CancelTask(id, callback) {
        $Dialog.Loading(i18n.t('dialog[2]'));
        const getResponse = ({ data }) => {
            callback && callback(data);
            $Dialog.Toast(data.code_dec);
        }
        axios.post('task/revokeTask', {id: id}).then(getResponse);
    },
    TaskOrderInfo(id, callback) {
        const getResponse = ({ data }) => {
            callback && callback(data);
        }
        axios.post('task/taskorderinfo', {order_id: id}).then(getResponse);
    },
    AuditTask(json, callback) {
        $Dialog.Loading(i18n.t('dialog[2]'));
        const getResponse = ({ data }) => {
            callback && callback(data);
            $Dialog.Toast(data.code_dec);
        }
        axios.post('task/taskOrderTrial', json).then(getResponse);
    },
    DailyReport(callback) {
        const getResponse = ({ data }) => {
            callback && callback(data);
        }
        axios.post('User/dailyReport').then(getResponse);
    },
	Office(id,callback) {
	    const getResponse = ({ data }) => {
	        callback && callback(data);
	    }
	    axios.post('Office/directLine',{id: id}).then(getResponse);
	},
	JobStatistics(callback) {
	    const getResponse = ({ data }) => {
	        callback && callback(data);
	    }
	    axios.post('Office/getJobStatistics').then(getResponse);
	},
	Apply(callback) {
	    const getResponse = ({ data }) => {
	        callback && callback(data);
	    }
	    axios.post('office/apply').then(getResponse);
	},
	GetJobStatus( callback) {
	    const getResponse = ({ data }) => {
	        callback && callback(data);
	    }
	    axios.post('office/getJobStatus').then(getResponse);
	},
    CreditList(callback) {
        const getResponse = ({ data }) => {
            callback && callback(data);
        }
        axios.post('user/getUserCreditList').then(getResponse);
    },
    TeamReport(json,callback) {
        const getResponse = ({ data }) => {
            callback && callback(data);
        }
        axios.post('user/teamReport',json).then(getResponse);
    },
    newLc(json,callback) {
        const getResponse = ({ data }) => {
            callback && callback(data);
        }
        axios.post('Yuebao/getYuebaoList',json).then(getResponse);
    },
    GetYuebaoinfo(id, callback) {
	    const getResponse = ({ data }) => {
	        callback && callback(data);
	    }
	    axios.post('Yuebao/getYuebaoinfo', {id: id}).then(getResponse);
	},
    newLcTj(json,callback) {
        const getResponse = ({ data }) => {
            callback && callback(data);
        }
        axios.post('Yuebao/payYuebao',json).then(getResponse);
    },
    newList(json,callback) {
        const getResponse = ({ data }) => {
            callback && callback(data);
        }
        axios.post('Yuebaojilu/getYuebaojiluList',json).then(getResponse);
    },
    yeb(json,callback) {
        const getResponse = ({ data }) => {
            callback && callback(data);
        }
        axios.post('Yuebao/showMoney',json).then(getResponse);
    },
	luckyRecord(json,callback) {
	    const getResponse = ({ data }) => {
	        callback && callback(data);
	    }
	    axios.post('user/getLotteryRecord',json).then(getResponse);
	},
	getDirect(json, callback) {
	  const getResponse = ({ data }) => {
	    callback && callback(data);
	  };
	  axios.post("Doing/rule", json).then(getResponse);
	},
	doDirect(id, callback) {
	  const getResponse = ({ data }) => {
	    callback && callback(data);
	  };
	  axios.post("Doing/receive", { id: id }).then(getResponse);
	},
	doBonus(pwd,callback){
		const getResponse = ({ data }) => {
		  callback && callback(data);
		};
		axios.post("Red/getRedEnvelope", { code: pwd }).then(getResponse);
	},
    GetActivityList(json, callback) {
        const getResponse = ({ data }) => {
            callback && callback(data);
        };
        axios.post("Activity/getActivityList", json).then(getResponse);
    },
    doActivity(json, callback) {
        const getResponse = ({ data }) => {
            callback && callback(data);
        };
        axios.post("Activity/doActivity", json).then(getResponse);
    },
     getUserPosts(callback) {
        const getResponse = ({ data }) => {
        callback && callback(data);
        };
        axios.post("User/userPosts").then(getResponse);
    },
    addPostAudit(json,callback) {
        const getResponse = ({ data }) => {
        callback && callback(data);
        };
        axios.post("User/addPostAudit",json).then(getResponse);
    },
    getPostAudit(callback) {
        const getResponse = ({ data }) => {
            callback && callback(data);
        };
        axios.post("User/getPostAudit").then(getResponse);
    },
    getPostInfo(callback) {
        const getResponse = ({ data }) => {
            callback && callback(data);
        };
        axios.post("User/getPostInfo").then(getResponse);
    },
    getDailyTaskProgress(callback) {
        const getResponse = ({ data }) => {
            callback && callback(data);
        };
        axios.post("User/getDailyTaskProgress").then(getResponse);
    },
    submitTfCrad(callback) {
        const getResponse = ({ data }) => {
            callback && callback(data);
        };
        axios.post("User/submitTfCrad").then(getResponse);
    },

    // Facebook像素转化事件方法
    /**
     * 发送Facebook像素购买事件
     * @param {object} purchaseData - 购买数据
     */
    trackFacebookPurchase(purchaseData) {
        FacebookPixel.trackPurchase(purchaseData);
    },
    
    /**
     * 发送Facebook像素添加购物车事件
     * @param {object} cartData - 购物车数据
     */
    trackFacebookAddToCart(cartData) {
        FacebookPixel.trackAddToCart(cartData);
    },
    
    /**
     * 发送Facebook像素开始结账事件
     * @param {object} checkoutData - 结账数据
     */
    trackFacebookInitiateCheckout(checkoutData) {
        FacebookPixel.trackInitiateCheckout(checkoutData);
    },
    
    /**
     * 发送自定义Facebook像素事件
     * @param {string} eventName - 事件名称
     * @param {object} parameters - 事件参数
     */
    trackFacebookEvent(eventName, parameters = {}) {
        FacebookPixel.trackEvent(eventName, parameters);
    },
    
    /**
     * 发送Facebook像素自定义事件（非标准事件）
     * @param {string} eventName - 事件名称
     * @param {object} parameters - 事件参数
     */
    trackFacebookCustomEvent(eventName, parameters = {}) {
        FacebookPixel.trackCustomEvent(eventName, parameters);
    },
    
    /**
     * 发送Facebook像素增强事件
     * @param {string} eventName - 事件名称
     * @param {object} parameters - 事件参数
     */
    trackFacebookEnhancedEvent(eventName, parameters = {}) {
        FacebookPixel.trackEnhancedEvent(eventName, parameters);
    },
    
    /**
     * 设置Facebook像素用户数据（用于高级匹配）
     * @param {object} userData - 用户数据
     */
    setFacebookUserData(userData) {
        FacebookPixel.setUserData(userData);
    },
    
    /**
     * 启用Facebook像素自动高级匹配
     */
    enableFacebookAutoAdvancedMatching() {
        FacebookPixel.enableAutoAdvancedMatching();
    },
    
    /**
     * 禁用Facebook像素自动高级匹配
     */
    disableFacebookAutoAdvancedMatching() {
        FacebookPixel.disableAutoAdvancedMatching();
    }
}

export default model
